<div class="app-layout">
  <div class="app-content">
    <router-outlet></router-outlet>
  </div>
  @if (isCopilotOpen$ | async) {
    <app-copilot-sidebar class="copilot-sidebar"></app-copilot-sidebar>
  }
</div>
